<template>
  <div>
    <div class="mt-4">
      <ul class="non-list box1_t1">
        <li>
          <h3 class="text-box1">{{ header }}</h3>
        </li>
      </ul>
    </div>

    <div style="display: flex; position: relative">
      <div style="width: 20%">
        <img
          v-if="['Total Rain Volume'].includes(header)"
          src="@/assets/images/NikhomLatKrabang/Rain-Volume-unscreen.gif"
          class="sizet2"
        />
        <img
          v-else
          src="@/assets/images/NikhomLatKrabang/wind.gif"
          class="sizet2"
        />
      </div>
      <div style="width: 80%">
        <ul class="non-list box1_t1">
          <li>
            <h1 class="text-box2">
              {{ value_day }}
              <sub v-if="header == 'Total Rain Volume'"> mm</sub>
              <sub v-else> kWh</sub>
            </h1>
          </li>
        </ul>
        <br />
        <div class="box1_t2 mr-4">
          <ul class="non-list">
            <li>
              <h5>
                Monthy Volume <a class="text-w">{{ value_month }}</a>
                <span v-if="header == 'Total Rain Volume'"> mm</span>
                <span v-else> kWh</span>
              </h5>
            </li>
            <li class="mt-4">
              <h5>
                Yearly Volume <a class="text-w">{{ value_year }}</a>
                <span v-if="header == 'Total Rain Volume'"> mm</span>
                <span v-else> kWh</span>
              </h5>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["header", "value_day", "value_month", "value_year"],
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped>
.non-list {
  list-style: none;
}
.box1_t1 {
  display: grid;
  justify-items: center;
}
.box1_t2 {
  display: flex;
  justify-content: flex-end;
}
.sizet2 {
  width: 30%;
  position: absolute;
  left: 0;
  bottom: 0;
}
.text-box1 {
  /* font-size: 2vw; */
  white-space: nowrap;
  font-weight: 600;
  color: #707070;
}

.text-box2 {
  /* font-size: 2.5vw; */
  font-size: calc(1rem + 1.2vw);
  white-space: nowrap;
  font-weight: 600;
  color: #707070;
}
@media only screen and (max-width: 700px) {
  .text-box1 {
    font-size: 2rem;
  }
}
</style>